// Banner.js
import React from 'react';
import './Banner.css';

const Banner = () => {
    return (
        <div className="banner-container">
            <div className="banner-content">
                <div className="left-content">
                    <h2>
                        Find Your Perfect Partner with Vihana Matrimony!
                    </h2>
                    <p className="banner-description">
                        Discover meaningful connections and build a beautiful future together. Join <span className="emphasize-body">Vihana Matrimony</span>, where tradition meets technology for seamless matchmaking. Start your journey today!
                    </p>
                    <div className="badges">
                        <a href='https://play.google.com/store/apps/details?id=com.chellobee.vihanamatrimony' target="_blank" rel="noopener noreferrer"><img src={process.env.PUBLIC_URL + "/images/google-play-badge.svg"} alt="Get it on Google Play" /></a>
                        <a href='https://apps.apple.com/in/app/vihana-matrimony-matchmaking/id6742974280' target="_blank" rel="noopener noreferrer" ><img src={process.env.PUBLIC_URL + "/images/app-store-badge.svg"} alt="Download on the App Store" /></a>
                    </div>
                </div>
                <div className="right-content">
                    <img src={process.env.PUBLIC_URL + "/images/banner-image.png"} alt="GrandQuiz App" />
                </div>
            </div>
            <div className="banner-bg">
                <img src={process.env.PUBLIC_URL + "/images/banner-bg-1.svg"} alt="Marketplace" />

            </div>
        </div>
    );
};

export default Banner;
